import { render, staticRenderFns } from "./SKModal.vue?vue&type=template&id=b82c74f0&"
import script from "./SKModal.vue?vue&type=script&lang=js&"
export * from "./SKModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports